export default class BPArtikelAnzahlRequest {
  id: string
  artikelId: string
  loeschen: boolean = false
  anzahl: number
}
